// IP Anchor's page address. The module moved from /ip-anchor to /ipanchor; old links (bookmarks,
// earlier sponsor notices) are redirected with their path, query and hash kept.

export const IP_ANCHOR_PATH = '/ipanchor';

/** The /ipanchor equivalent of a legacy /ip-anchor address, or null when it is not one. */
export function legacyIpAnchorTarget(pathname: string, search = '', hash = ''): string | null {
  const match = /^\/ip-anchor(?=\/|$)/i.exec(pathname);
  if (!match) return null;
  return `${IP_ANCHOR_PATH}${pathname.slice(match[0].length)}${search}${hash}`;
}
